module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("fiZX9"))).then(() => parcelRequire('7VwkY'));